module.exports = __webpack_public_path__ + "media/images/search_ic-ddbc13692ee1125aba59d6d8b51456e0.svg";